<script>
import Navbar from "@/components/navbar";
import Services from "@/components/services";
import Features from "@/components/features";
//import Blog from "@/components/blog";
import Contact from "@/components/contact";
import Footer from "@/components/footer";
import Conoce from "../components/conoce.vue";
import Coberturas from "../components/coberturas.vue";

/**
 * index-1 component
 */
export default {
  name: "index-1",
  components: {
    Navbar,
    Services,
    Conoce,
    Coberturas,
    Features,
    //Blog,
    Contact,
    Footer,
  },
};
</script>

<template>
  <div>
    <Navbar />
    <div v-scroll-spy>
      <!--START HOME-->
      <section class="section bg-home home-half" id="home"
        :style="{ 'background-image': 'url(' + require('@/assets/images/ca.jpg') + ')', 'background-size': 'cover', 'background-position': 'center' }">
        <div class="bg-overlay"></div>
        <div class="display-table">
          <div class="display-table-cell">
            <div class="container">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 class="home-title">¡Bienvenido a
                    MÉXICO!</h1>
                  <a href="https://public.nhseguros.com/#!policyIndividual/index?code=MjI4MDc%3D" target="_blank"
                    class="btn btn-custom btn-rounded margin-t-30 waves-effect waves-light mb-5">Compra tu seguro</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-pattern-effect">
          <img src="@/assets/images/bg-pattern.png" alt />
        </div>
      </section>
      <!--END HOME-->
      <Services />
      <Conoce />
      <Coberturas />
      <Features />
      <Blog />
      <Contact />
      <Footer />
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}

::v-deep .modal-header {
  border: none;
}

::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>